/**
 * Where a popup cannot deliver an OAuth result, and a top-level redirect has
 * to take over.
 *
 * This lived inside gisRedirect.ts until Dropbox and OneDrive needed the same
 * answer. Three copies of a browser-sniff that must agree is two copies too
 * many - if one of them ever drifts, one provider silently goes back to
 * opening popups that iOS throws away.
 */

export function isIos() {
  return (
    /iP(hone|ad|od)/.test(window.navigator.platform) ||
    // iPadOS 13+ reports itself as a Mac and is only distinguishable by touch.
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
  );
}

/**
 * Popups still work on desktop, and a popup does not tear the app down the
 * way a redirect does. So redirect only where the popup cannot deliver.
 * (Google is the exception and redirects everywhere - see googleAuth.ts -
 * so it does not ask this.)
 *
 * iOS only, and deliberately not "is this a standalone launch".
 *
 * The first version of this asked `isStandalone() || isIos()`, which is wrong
 * in both directions of the thing it was trying to capture. A desktop PWA is
 * standalone and opens popups perfectly well; it was pushed onto the redirect
 * path and, worse, told it could not authorise in place at all - so the player
 * stopped offering to sign in and just reported the problem. The constraint
 * was never "standalone", it is "WebKit on iOS", and that is what isIos()
 * already answers, home screen or not.
 */
export function shouldUseRedirect() {
  return isIos();
}
